export const date = {
    name: "date",
    description: "Shows current date and time",
    run: () => new Date().toString(),
};